<template>
    <div class="basic_wrap mt44">
       
        <BaseHeader :title="$t('safe.setting')"></BaseHeader>
        
        <div class="wrap_box">
            <router-link to="/account" class="item">
                <div class="left">
                    <img class="icon" src="../images/wallet.png" alt="">
                    <span class="info">{{ $t('safe.paymentOptions') }}</span>
                </div>
                <div class="right icon_right"></div>
            </router-link>
            <router-link to="/language" class="item">
                <div class="left">
                    <img class="icon" src="../images/language.png" alt="">
                    <span class="info">{{ $t('safe.language') }}</span>
                </div>
                <div class="right icon_right"></div>
            </router-link>
            <router-link to="/setpwd" class="item">
                <div class="left">
                    <img class="icon" src="../images/lock.png" alt="">
                    <span class="info">{{ $t('safe.signInPassword') }}</span>
                </div>
                <div class="right icon_right"></div>
            </router-link>
            <router-link to="/setpaypwd" class="item">
                <div class="left">
                    <img class="icon" src="../images/code.png" alt="">
                    <span class="info">{{ $t('safe.paymentPassword') }}</span>
                </div>
                <div class="right icon_right"></div>
            </router-link>
            <router-link to="/about/12" class="item">
                <div class="left">
                    <img class="icon" src="../images/sign.png" alt="">
                    <span class="info">{{ $t('index.agreement') }}</span>
                </div>
                <div class="right icon_right"></div>
            </router-link>
            <router-link to="/about/13" class="item">
                <div class="left">
                    <img class="icon" src="../images/user.png" alt="">
                    <span class="info">{{ $t('index.secret') }}</span>
                </div>
                <div class="right icon_right"></div>
            </router-link>
        </div>
        
        <div class="history_coupon flex_center" @click="logout">
            {{ $t('safe.signOut') }}
        </div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch'
import BaseHeader from "@/components/baseHeader";

export default {
    name: "safe",
    components: {
        BaseHeader
    },
    data() {
        return {
            data: {},
            appVer: "",
            wgtVer: "",
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.start();
        //this.getVersion();
    },
    methods: {
        start() {
            Fetch('/user/info').then((r) => {
                this.data = r.data;
            });
        },
        logout() {
            localStorage.removeItem('token');
            this.$router.replace("/");
        },
    }
};
</script>

<style lang="less" scoped>
.left{
    display: flex;
    padding-left: 15px;
}
.icon {
    width: 20px;
    margin-right: 10px;
    height: 20px;
}

.back_left {
    background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
    color: #000000;
}

.wrap_box {
    
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #2B3864;
    width: 95%;
    margin: 12px auto;
    
    .item {
        height: 50px;
        width: 95%;
        padding: 16px 0;
        border-bottom: 1px solid #3A4A7C;
        font-size: 14px;
        color: #ffffff;
        font-weight: bold;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        
        .right {
            width: 20px;
            height: 20px;
            background: url(../images/bright.png) no-repeat center center;
            background-size: 50% 50%;
            background-position: center;
        }
        
        .right_info {
            color: rgba(0, 0, 0, .6);
        }
        
        .tips {
            color: rgba(0, 0, 0, .6);
            margin-left: auto;
            margin-right: 4px;
            font-weight: normal;
        }
    }
}

.history_coupon {
    margin: 35px auto 0 auto;
    width: 95%;
    height: 40px;
    font-weight: 700;
    font-size: 0.45rem;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    border-radius: 15px;
    background: linear-gradient(#fbe4cb, #e7bb90);
    color: #512E20;
}



.auth {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
</style>
